import meta from '../metas/slider';
export default {
  meta
};